import { BlockConfig, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const graphDbConfig: BlockConfig = {
  displayName: "Graph DB",
  imagePath: "",
  isInitiator: true,
  isTerminator: false,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.CACHE,
    BlockTypes.LAMBDA,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set(),
  inputCapacity: {
    total: 5000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 3500,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 1500,
          [`${ContentTypes.STATIC}`]: 2000,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 1500,
        byContentType: { [`${ContentTypes.DYNAMIC}`]: 1500 },
      },
    },
  },
  processingCapacity: {
    total: 5000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 3500,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 1500,
          [`${ContentTypes.STATIC}`]: 2000,
        },
      },
      [`${OperationTypes.WRITE}`]: {
        total: 1500,
        byContentType: { [`${ContentTypes.DYNAMIC}`]: 1500 },
      },
    },
  },
  purchasePrice: 200,
  sellPrice: 100,
  costPerCycle: 1.5,
  outputConnectorLimits: {},
};
